import { useContent } from "@/context/ContentContext";
import PagePlacements from "@/components/PagePlacements";

export default function Rodo() {
  const { pages } = useContent();
  const rodo = pages?.rodo || {};

  return (
    <div data-testid="rodo-page" className="relative max-w-4xl mx-auto px-6 py-20">
      <div className="text-white/70 text-xs uppercase tracking-widest font-semibold">Dokumenty</div>
      <h1 data-testid="rodo-title" className="font-display text-4xl sm:text-5xl font-black text-white mt-3">
        {rodo.title || "KLAUZULA INFORMACYJNA"}
      </h1>
      {rodo.subtitle && (
        <p data-testid="rodo-subtitle" className="text-white/70 mt-3">
          {rodo.subtitle}
        </p>
      )}

      <div className="rm-card p-8 md:p-10 mt-10 leading-relaxed text-slate-700">
        {rodo.intro && (
          <p data-testid="rodo-intro" className="text-slate-800 font-medium mb-6">
            {rodo.intro}
          </p>
        )}
        <div
          data-testid="rodo-body"
          className="whitespace-pre-line text-slate-700 text-sm sm:text-base"
        >
          {rodo.body || "Treść klauzuli jest w przygotowaniu."}
        </div>
      </div>
      <PagePlacements page="rodo" />
    </div>
  );
}
